module.exports = __webpack_public_path__ + "img/current_account.7d7326c.svg";